import React, { useEffect, useState } from "react";
import {
  Container,
  Card,
  Form,
  Button,
  Alert,
  Row,
  Col,
  Modal,
  InputGroup,
  Badge,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import {
  getActiveMemberTypeList,
  getCountryActiveListApi,
  sendOtpWithRegistration_NewApi,
  sendOtpWithRegistrationApi,
} from "./RamNamBookCRUD";
import LoginPage from "../auth-pages/LoginPage";
import { FaArrowCircleLeft } from "react-icons/fa";
import { CountryData } from "../other-drop-downs/OtherDropDowns";

/* ---------------- Validation Schema ---------------- */
const validationSchema = Yup.object({
  memberName: Yup.string()
    .min(3, "Name must be at least 3 characters long")
    .required("Name is required"),
  mobileNumber: Yup.string()
    // .matches(/^[0-9]{9,10}$/, "Please enter a valid mobile number")
    .required("Mobile number is required"),
  countryID: Yup.number().required("Please select a country"),
  // memberTypeID: Yup.number().required("Please select a type"),
  villageCityName: Yup.string().required("Village / City name is required"),
  pincode: Yup.string()
    .matches(/^[a-zA-Z0-9]+$/, "Pincode can be alphanumeric")
    .min(4, "Minimum 4 characters required")
    .max(14, "Maximum 14 characters allowed")
    .required("Pincode is required"),
  address: Yup.string().required("Address is required"),
  password: Yup.string()
    .min(4, "Password must be at least 4 characters")
    .max(12, "Password must not exceed 12 characters")
    .required("Password is required"),

  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password is required"),
  termsAccepted: Yup.boolean()
    .oneOf([true], "You must accept the terms and conditions")
    .required(),
});

const RamNamBookRegister = () => {
  const navigate = useNavigate();
  const MEMBER_WEB = process.env.REACT_APP_MEMBER_WEB_URL;
  const [countryID, setCountryID] = useState(22); // India default
  const [countryDialCode, setCountryDialCode] = useState("+91");
  const [countryMobileLength, setCountryMobileLength] = useState(10);
  const [showDialDropdown, setShowDialDropdown] = useState(false);
  const formik = useFormik({
    initialValues: {
      memberName: "",
      mobileNumber: "",
      countryID: 22,
      dialCode: "+91",
      memberTypeID: 1,
      villageCityName: "",
      pincode: "",
      address: "",
      password: "",
      confirmPassword: "",
      termsAccepted: false,
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting, setStatus }) => {
      // 🔗 CALL SEND OTP API HERE
      await sendOtpWithRegistration_NewApi(
        values.mobileNumber,
        values.memberName,
        countryID,
        countryDialCode,
        1,
        values.villageCityName,
        values.pincode,
        values.address,
        values.termsAccepted,
        values.password,
        values.confirmPassword,
      )
        .then((response) => {
          if (response.data.isSuccess === true) {
            if (countryID == 22) {
              toast.success(`${response.data?.message}`);
              sessionStorage.setItem("otpAllowed", "true");
              navigate(
                "/verify-otp",
                {
                  state: {
                    otpdata: response.data?.data,
                    // mode: "registration",
                    memberID: response.data.memberID,
                    countryID,
                    countryDialCode,
                  },
                },
                { replace: true },
              );
            } else {
              toast.success("Registration successfully.");
              navigate("/");
            }
          } else {
            toast.error(`${response.data?.message}`);
          }
        })
        .catch((error) => {
          toast.error(`${error.message}`);
        });
    },
  });

  useEffect(() => {
    const defaultCountry = CountryData.find((c) => c.countryID === 22);
    if (defaultCountry) {
      formik.setFieldValue("countryID", defaultCountry.countryID);
      formik.setFieldValue("dialCode", defaultCountry.countryDialNumber);
    }
    console.log("values.dialCode", defaultCountry.countryDialNumber);
  }, []);
  console.log("countryDialCode", countryDialCode);
  console.log("countryID", countryID);

  const handleOpenMemberSite = () => {
    window.open(`${MEMBER_WEB}`, "_blank");
  };
  return (
    <>
      {" "}
      <div
        className="container-fluid"
        style={{
          marginTop: "calc(var(--header-height) * -1)",
          // minHeight: "95vh",
        }}
      >
        <Row
        // className="bg-light"
        // style={{
        //   marginTop: "calc(var(--header-height) * -1)",
        //   paddingTop: "0",
        // }}
        >
          {/* ================= LEFT HEADER ================= */}
          <Col
            lg={5}
            md={12}
            className="d-flex align-items-center justify-content-center text-center"
            style={{ backgroundColor: "#FF4F00" }}
          >
            <div className="d-flex flex-column align-items-center justify-content-center">
              <img
                src="/assets/logo/barejadham1.png"
                alt="Khunkhaar Meldi Maa"
                className="img-fluid"
                style={{
                  maxHeight: "30vh",
                  maxWidth: "30vw",
                  cursor: "pointer",
                  animation: "pulseZoom 2.5s infinite",
                }}
                onClick={() => navigate("/")}
              />
              <img
                src="/assets/logo/Picsart_26-01-22_14-35-30-548.png"
                alt="Khunkhaar Meldi Maa"
                className="img-fluid m-0"
                style={{
                  maxHeight: "55vh",
                  maxWidth: "55vw",
                  cursor: "pointer",
                  animation: "pulseZoom 2.5s infinite",
                }}
                onClick={() => navigate("/")}
              />
            </div>
          </Col>

          {/* ================= RIGHT FORM ================= */}
          <Col
            lg={7}
            md={12}
            className="d-flex align-items-center justify-content-center"
          >
            <Card className="shadow border-0 rounded-0 w-100 bg-white">
              <p
                className="doha-text mt-3"
                style={{
                  fontSize: "18px",
                  lineHeight: "1.8",
                  fontWeight: "500",
                  color: "#FF4F00",
                  textAlign: "center",
                  // margin: "20px 0",
                  // fontFamily: "'Poppins', 'Noto Sans Devanagari', sans-serif",
                }}
              >
                राम-नाम-मनि-दीप धरु, जीह देहरी द्वार।
                <br />
                तुलसी भीतर बाहेरौ, जो चाहसि उजियार॥
              </p>
              {/* <div className="d-flex flex-column align-items-center justify-content-center">
                <img
                  src="/assets/logo/barejadham1.png"
                  alt="Khunkhaar Meldi Maa"
                  className="img-fluid"
                  style={{
                    maxWidth: "60px",
                    cursor: "pointer",
                    animation: "pulseZoom 2.5s infinite",
                  }}
                  onClick={() => navigate("/")}
                />
              </div> */}
              <Card.Body className="p-md-5">
                {formik.status && (
                  <Alert variant="danger">{formik.status}</Alert>
                )}

                <Form noValidate onSubmit={formik.handleSubmit}>
                  {/* Name */}
                  <Row className="mb-2">
                    {/* <Col lg={6} md={6} sm={12}>
                      <Form.Group className="mb-2">
                        <Form.Label>
                          સભ્ય પ્રકાર / सदस्य प्रकार / Member Type{" "}
                          <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          name="memberTypeID"
                          value={formik.values.memberTypeID}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          isInvalid={
                            formik.touched.memberTypeID &&
                            !!formik.errors.memberTypeID
                          }
                        >
                          <option value="">select member type</option>
                          {memberTypes.map((c) => (
                            <option key={c.memberTypeID} value={c.memberTypeID}>
                              {c.memberType}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.memberTypeID}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col> */}
                    <Col lg={12} md={12} sm={12}>
                      <Form.Group className="mb-2">
                        <Form.Label>
                          સંપૂર્ણ નામ / पूरा नाम / Full Name{" "}
                          <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="memberName"
                          placeholder="Enter your name"
                          value={formik.values.memberName}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          isInvalid={
                            formik.touched.memberName &&
                            !!formik.errors.memberName
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.memberName}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-0">
                    {/* 📱 Mobile Number + Dial Code */}
                    <Col lg={6} md={6} sm={12}>
                      <Form.Group className="mb-2">
                        <Form.Label>
                          મોબાઈલ નંબર / मोबाइल नंबर / Mobile Number{" "}
                          <span className="text-danger">*</span>
                        </Form.Label>

                        <InputGroup>
                          {/* ----------- IMAGE FLAG DIAL DROPDOWN ----------- */}
                          <div
                            style={{
                              position: "relative",
                              maxWidth: "120px",
                              minWidth: "120px",
                            }}
                          >
                            {/* Selected Dial */}
                            <div
                              className="form-select d-flex align-items-center gap-2"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                setShowDialDropdown(!showDialDropdown)
                              }
                            >
                              {(() => {
                                const selected = CountryData.find(
                                  (c) => c.countryID === countryID,
                                );
                                // setCountryDialCode(selected.countryDialNumber);
                                return selected ? (
                                  <>
                                    <img
                                      src={selected.flagPath}
                                      alt={selected.countryName}
                                      width="20"
                                      height="15"
                                      style={{ objectFit: "cover" }}
                                    />
                                    <span>{selected.countryDialNumber}</span>
                                  </>
                                ) : (
                                  "Select"
                                );
                              })()}
                            </div>

                            {/* Dropdown List */}
                            {showDialDropdown && (
                              <div
                                className="border bg-white shadow"
                                style={{
                                  position: "absolute",
                                  width: "100%",
                                  maxHeight: "250px",
                                  overflowY: "auto",
                                  zIndex: 9999,
                                }}
                              >
                                {CountryData.map((c) => (
                                  <div
                                    key={c.countryID}
                                    className="d-flex align-items-center gap-2 p-2"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setCountryID(c.countryID);
                                      setCountryDialCode(c.countryDialNumber);
                                      setCountryMobileLength(c.mobileLength);
                                      setShowDialDropdown(false);
                                      formik.setFieldValue(
                                        "countryID",
                                        c.countryID,
                                      );
                                      formik.setFieldValue(
                                        "dialCode",
                                        c.countryDialNumber,
                                      );
                                      formik.setFieldValue("mobileNumber", "");
                                      setShowDialDropdown(false);
                                    }}
                                  >
                                    <img
                                      src={c.flagPath}
                                      alt={c.countryName}
                                      width="20"
                                      height="15"
                                    />
                                    <span>{c.countryDialNumber}</span>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>

                          {/* Mobile Input */}
                          <Form.Control
                            type="text"
                            maxLength={countryMobileLength}
                            value={formik.values.mobileNumber}
                            onChange={(e) => {
                              const value = e.target.value
                                .replace(/\D/g, "")
                                .slice(0, countryMobileLength);
                              formik.setFieldValue("mobileNumber", value);
                            }}
                            placeholder={`Enter ${countryMobileLength} digit mobile number`}
                            isInvalid={
                              formik.touched.mobileNumber &&
                              !!formik.errors.mobileNumber
                            }
                          />
                        </InputGroup>
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.mobileNumber}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    {/* Country Dropdown */}
                    <Col lg={6} md={6} sm={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Country <span className="text-danger">*</span>
                        </Form.Label>

                        <Form.Select
                          value={countryID}
                          onChange={(e) => {
                            const selectedID = Number(e.target.value);
                            setCountryID(selectedID);

                            const selected = CountryData.find(
                              (c) => c.countryID === selectedID,
                            );
                            if (!selected) return;

                            formik.setFieldValue(
                              "countryID",
                              selected.countryID,
                            );
                            formik.setFieldValue(
                              "dialCode",
                              selected.countryDialNumber,
                            );
                            setCountryMobileLength(selected.mobileLength);
                            formik.setFieldValue("mobileNumber", "");
                          }}
                          isInvalid={
                            formik.touched.countryID &&
                            !!formik.errors.countryID
                          }
                        >
                          <option value="">Select Country</option>
                          {CountryData.map((c) => (
                            <option key={c.countryID} value={c.countryID}>
                              {c.countryName}
                            </option>
                          ))}
                        </Form.Select>

                        <Form.Control.Feedback type="invalid">
                          {formik.errors.countryID}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="">
                    <Col>
                      <Form.Group className="mb-0">
                        <Form.Label>New Password</Form.Label>
                        <Form.Control
                          type="password"
                          name="password"
                          value={formik.values.password}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          isInvalid={
                            formik.touched.password && !!formik.errors.password
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.password}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="mb-2">
                        <Form.Label>Confirm Password</Form.Label>
                        <Form.Control
                          type="Password"
                          name="confirmPassword"
                          value={formik.values.confirmPassword}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          isInvalid={
                            formik.touched.confirmPassword &&
                            !!formik.errors.confirmPassword
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.confirmPassword}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mb-1">
                    <Col lg={6} md={6} sm={12}>
                      {/* Village */}
                      <Form.Group className="mb-2">
                        <Form.Label>
                          ગામ / गाँव / Village / City{" "}
                          <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="villageCityName"
                          placeholder="Enter your village/city"
                          value={formik.values.villageCityName}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          isInvalid={
                            formik.touched.villageCityName &&
                            !!formik.errors.villageCityName
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={6} md={6} sm={12}>
                      {/* Pincode */}
                      <Form.Group className="mb-2">
                        <Form.Label>
                          પિનકોડ / पिनकोड / Pincode{" "}
                          <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="xxxxxx"
                          name="pincode"
                          value={formik.values.pincode}
                          onChange={(e) => {
                            const value = e.target.value.replace(
                              /[^a-zA-Z0-9]/g,
                              "",
                            );
                            formik.setFieldValue("pincode", value);
                          }}
                          onBlur={formik.handleBlur}
                          maxLength={14}
                          isInvalid={
                            formik.touched.pincode && !!formik.errors.pincode
                          }
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  {/* Address */}
                  <Form.Group className="mb-2">
                    <Form.Label>
                      સરનામું / पता / Address{" "}
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      placeholder="Enter your address"
                      rows={2}
                      name="address"
                      value={formik.values.address}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={
                        formik.touched.address && !!formik.errors.address
                      }
                    />
                  </Form.Group>

                  {/* Terms */}
                  <Form.Group className="mb-1">
                    <Form.Switch
                      type="checkbox"
                      name="termsAccepted"
                      checked={formik.values.termsAccepted}
                      onChange={formik.handleChange}
                      label={
                        <>
                          {" "}
                          <span
                            style={{
                              color: "#FF4F00",
                              cursor: "pointer",
                              textDecoration: "underline",
                            }}
                            onClick={() => navigate("/terms-condition")}
                          >
                            હું નિયમો અને શરતો સ્વીકારું છું/ I agree to the
                            terms & conditions
                          </span>
                        </>
                      }
                      isInvalid={
                        formik.touched.termsAccepted &&
                        !!formik.errors.termsAccepted
                      }
                    />{" "}
                    {formik.touched.termsAccepted &&
                      formik.errors.termsAccepted && (
                        <div
                          className="text-danger mt-1"
                          style={{ fontSize: "0.85rem" }}
                        >
                          {formik.errors.termsAccepted}
                        </div>
                      )}
                  </Form.Group>

                  {/* Submit */}
                  <Button
                    type="submit"
                    className="w-100"
                    disabled={formik.isSubmitting}
                    style={{ backgroundColor: "#FF4F00" }}
                  >
                    {formik.isSubmitting ? "Submitting..." : "Submit"}
                  </Button>
                  <p className="text-center mt-1">
                    Already have an account?{" "}
                    <a
                      className="hover:underline text-primary"
                      onClick={handleOpenMemberSite}
                    >
                      Login
                    </a>
                  </p>
                  {/* <LoginPage
                    show={showLogin}
                    onHide={() => setShowLogin(false)}
                  /> */}
                  <div className="justify-center d-flex">
                    <Badge
                      className="cursor-pointer d-flex"
                      onClick={() => navigate("/")}
                    >
                      <FaArrowCircleLeft />
                      &nbsp; back to home
                    </Badge>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
      {/* Animation */}
      <style>
        {`
          @keyframes pulseZoom {
            0% { transform: scale(1); }
            50% { transform: scale(1.08); }
            100% { transform: scale(1); }
          }
        `}
      </style>
      {/* <Modal show={showTerms} onHide={handleCloseTerms} centered size="md">
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#FF4F00" }}>
            Terms & Conditions
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
          <p className="text-dark">
            કૃપા કરીને તમામ વિગતો ભરો અને નિયમો તથા શરતો સ્વીકારો. <br />
            कृपया सभी विवरण भरें और नियम व शर्तें स्वीकार करें। <br />
            Please fill all details and accept the Terms & Conditions.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{ backgroundColor: "#FF4F00" }}
            onClick={handleCloseTerms}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal> */}
    </>
  );
};

export default RamNamBookRegister;
